import styled from "styled-components"

export const ErrorWrapper = styled.div`
display: flex;
align-items: center;

`
